module.exports = __webpack_public_path__ + "static/sample-0-56eb4664e52550e52050d3420170f723.png";